import {FileNameData} from '../FileNameData';

export class AbsenceRequest {
    id: number;
    employeeId?: number;
    absenceDay: number;
    absenceTypeId: number;
    absenceStartDate: string;
    absenceEndDate: string;
    description: string;
    filePath: string;
    freeDayAmount: number;
    readAndAprroved: number;
    absenceExcuseReasonId: number;
    fileList?: FileNameData[];
    proxyManagerId: number;

    constructor(id: number, employeeId: number, absenceDay: number, absenceTypeId: number, absenceStartDate: string,
                absenceEndDate: string, description: string, filePath: string, freeDayAmount: number, readAndAprroved: number,
                absenceExcuseReasonId: number, fileList: FileNameData[], proxyManagerId: number) {
        this.id = id;
        this.employeeId = employeeId;
        this.absenceDay = absenceDay;
        this.absenceTypeId = absenceTypeId;
        this.absenceStartDate = absenceStartDate;
        this.absenceEndDate = absenceEndDate;
        this.description = description;
        this.filePath = filePath;
        this.freeDayAmount = freeDayAmount;
        this.readAndAprroved = readAndAprroved;
        this.absenceExcuseReasonId = absenceExcuseReasonId;
        this.fileList = fileList;
        this.proxyManagerId = proxyManagerId;
    }
}
